
import { Component, Vue } from 'vue-property-decorator';
import BasePagina from '@/components/base/BasePagina.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BasePesquisa from '@/components/base/BasePesquisa.vue';
import BaseLista from '@/components/base/BaseLista.vue';
import BaseCampos from '@/components/base/BaseCampos.vue';
import DatePicker from '@/components/base/DatePicker.vue';
import TimePicker from '@/components/base/TimePicker.vue';
// Services
import PerguntaService from '@/services/pergunta.service';
// Models
import { PerguntaInterface } from '@/shared/models/pergunta/pergunta.interface';
import { PerguntaFilter } from '@/shared/models/pergunta/pergunta.filter';
import { BaseDialogInterface } from '@/shared/models/base/dialog.interface';
// Utils
import Rules from '@/shared/utils/rules.util';

@Component({
  components: {
    BasePagina,
    BaseDialog,
    BasePesquisa,
    BaseLista,
    BaseCampos,
    DatePicker,
    TimePicker,
  },
})
export default class Pergunta extends Vue {
  private rules = Rules;

  public labelBotaoNovo = 'Nova Pergunta';

  public editedItem = {} as PerguntaInterface;

  public filtro = {} as PerguntaFilter;

  public dateTimeInicia: Record<string, any> = { date: '', time: '' };

  public dateTimeExpira: Record<string, any> = { date: '', time: '' };

  public readonlyCamposDialog = false;

  // Dialog
  public dialogInterface = {
    formTitle: '',
    dialog: false,
    textBotaoPrimario: 'Salvar',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalEditar,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  // Campos do Dialog
  public lista: Array<PerguntaInterface> = [];

  public headers: Array<Record<string, any>> = [
    {
      text: 'Enunciado', value: 'enunciado', align: 'center', sortable: false,
    },
    // {
    // text: 'Data início', value: 'validadeInicio', align: 'center', sortable: false,
    // },
    // {
    //   text: 'Data fim', value: 'validadeFim', align: 'center', sortable: false,
    // },
    // {
    // text: 'Pontuação', value: 'pontuacao', align: 'center', sortable: false,
    // },
    {
      text: 'Ação', value: 'acao', align: 'center', sortable: false,
    },
  ];

  public colapses = [
    { titulo: 'Filtragem', nomeSlot: 'pesquisa' },
    { titulo: 'Lista de Perguntas', nomeSlot: 'lista' },
  ];

  public listaCamposPesquisa = [
    {
      text: 'Enunciado', type: 'textField', value: 'enunciado', cols: '4',
    },
    {
      text: 'Pontuação', type: 'textField', value: 'pontuacao', cols: '4',
    },
  ];

  public listaValues = [];

  public listaCamposEditar = [
    {
      text: 'Enunciado',
      type: 'textField',
      value: 'enunciado',
      cols: '12',
      counter: '100',
      maxlength: '100',
      required: true,
      rules: [this.rules.campo_obrigatorio],
    },
    {
      text: 'Link',
      type: 'textField',
      value: 'link',
      cols: '12',
      counter: '100',
      maxlength: '100',
      required: false,
    },
    {
      text: 'Pontuação',
      type: 'textField',
      value: 'pontuacao',
      cols: '12',
      counter: '100',
      maxlength: '100',
      required: true,
      rules: [this.rules.campo_obrigatorio],
      clearable: true,
    },
    {
      text: 'Resposta',
      type: 'textField',
      value: 'respostaCerta',
      cols: '12',
      counter: '100',
      maxlength: '100',
      required: true,
      rules: [this.rules.campo_obrigatorio],
      clearable: true,
    },
    {
      text: 'Resposta Errada',
      type: 'textField',
      value: 'respostaErrada1',
      cols: '12',
      counter: '100',
      maxlength: '100',
      required: true,
      rules: [this.rules.campo_obrigatorio],
      clearable: true,
    },
    {
      text: 'Resposta Errada',
      type: 'textField',
      value: 'respostaErrada2',
      cols: '12',
      counter: '100',
      maxlength: '100',
      required: true,
      rules: [this.rules.campo_obrigatorio],
      clearable: true,
    },
    {
      text: 'Resposta Errada',
      type: 'textField',
      value: 'respostaErrada3',
      cols: '12',
      counter: '100',
      maxlength: '100',
      required: true,
      rules: [this.rules.campo_obrigatorio],
      clearable: true,
    },
    // {
    //   text: 'Data Inicio',
    //   type: 'textField',
    //   value: 'validadeInicio',
    //   cols: '12',
    //   counter: '100',
    //   maxlength: '100',
    //   required: true,
    //   rules: [this.rules.campo_obrigatorio],
    //   clearable: true,
    // },
    // {
    //   text: 'Data Fim',
    //   type: 'textField',
    //   value: 'validadeFim',
    //   cols: '12',
    //   counter: '100',
    //   maxlength: '100',
    //   required: true,
    //   rules: [this.rules.campo_obrigatorio],
    //   clearable: true,
    // },
  ];

  public listaAcoes = [
    { tooltip: 'Editar', icon: 'mdi-square-edit-outline', function: this.abrirEditar },
    { tooltip: 'Excluir', icon: 'mdi-delete-outline', function: this.abrirExcluir },
  ];

  // Pesquisa
  async pesquisar(filtro: PerguntaFilter) {
    this.lista = await new PerguntaService().pesquisar(filtro);
  }

  async buscarTodos() {
    this.lista = await new PerguntaService().pesquisar({} as PerguntaFilter);
  }

  private abrirCriar() {
    this.dialogInterface.formTitle = 'Nova Pergunta';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.readonlyCamposDialog = false;
    this.dialogInterface.funcaoPrimaria = this.salvar;
    this.editedItem = {} as PerguntaInterface;
    this.dialogInterface.dialog = true;
  }

  // Dialog de Editar Pergunta
  private async abrirEditar(item: any) {
    this.dialogInterface.formTitle = 'Editar Pergunta';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.readonlyCamposDialog = false;
    this.dialogInterface.funcaoPrimaria = this.atualizar;
    this.editedItem = item;
    if (this.editedItem !== undefined) {
      if (this.editedItem.validadeInicio) this.dateTimeInicia = this.formataDateTimeEditar(this.editedItem.validadeInicio);
      if (this.editedItem.validadeFim) this.dateTimeExpira = this.formataDateTimeEditar(this.editedItem.validadeFim);
      this.dialogInterface.dialog = true;
    }
  }

  private async abrirExcluir(item: any) {
    this.dialogInterface.formTitle = 'Excluir Canal';
    this.dialogInterface.textBotaoPrimario = 'Excluir';
    this.readonlyCamposDialog = true;
    this.dialogInterface.colorBotaoPrimario = 'warning';
    this.dialogInterface.funcaoPrimaria = this.excluir;
    this.editedItem = item;
    if (this.editedItem !== undefined) {
      if (this.editedItem.validadeInicio) this.dateTimeInicia = this.formataDateTimeEditar(this.editedItem.validadeInicio);
      if (this.editedItem.validadeFim) this.dateTimeExpira = this.formataDateTimeEditar(this.editedItem.validadeFim);
      this.dialogInterface.dialog = true;
    }
  }

  async excluir() {
    new PerguntaService().excluir(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  async salvar() {
    this.editedItem.validadeInicio = this.formataDateTimeCadastrar(this.dateTimeInicia);
    this.editedItem.validadeFim = this.formataDateTimeCadastrar(this.dateTimeExpira);
    new PerguntaService().cadastrar(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  private fecharModalCriarEditar() {
    this.dialogInterface.dialog = false;
    this.editedItem = {} as PerguntaInterface;
  }

  async atualizar() {
    this.editedItem.validadeInicio = this.formataDateTimeCadastrar(this.dateTimeInicia);
    this.editedItem.validadeFim = this.formataDateTimeCadastrar(this.dateTimeExpira);
    new PerguntaService().atualizar(this.editedItem)
      .then(() => {
        this.fecharModalEditar();
        this.pesquisar({} as PerguntaFilter);
      });
  }

  private fecharModalEditar() {
    // TODO ao fechar a lista da grid esta sumindo
    this.dialogInterface.dialog = false;
    // TODO chamada de pesquisa adicionada provisoriamente ate resolver
    this.pesquisar({} as PerguntaFilter);
  }

  private formataDateTimeCadastrar(dateTime: Record<string, any>) {
    const [year, month, day] = (dateTime as any).date.split('-');
    return `${day}-${month}-${year} ${(dateTime as any).time.toString()}:00`;
  }

  private formataDateTimeEditar(dateTime: string) {
    const [day, month, year] = dateTime.substring(0, 10).split('-');
    return {
      date: `${year}-${month}-${day}`,
      time: `${dateTime.substring(11, 16).toString()}`,
    };
  }

  mounted() {
    this.buscarTodos();
  }
}
